import { Grid, Tooltip} from "@mui/material";

export function getStockoutproducttoproductorderStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        businessid:{
            name:'businessid',
            label:'Business Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        title:{
            name:'title',
            label:'Title',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        stockoutproductid:{
            name:'stockoutproductid',
            label:'stockoutproductid',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        productorderid:{
            name:'productorderid',
            label:'productorderid',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        orderid:{
            name:'orderid',
            label:'Order Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        qty:{
            name:'qty',
            label:'Qty',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        stockoutreqid:{
            name:'stockoutreqid',
            label:'Stock Out Req Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'title', headerName: 'Title', width:100 },
        { field: 'stockoutproductid', headerName: 'stockoutproductid', width:150 },
        { field: 'productorderid', headerName: 'productorderid', width:150 },
        { field: 'orderid', headerName: 'Order Id', width:150 },
        { field: 'qty', headerName: 'Qty', width:150 },
        { field: 'stockoutreqid', headerName: 'Stock Out Req Id', width:150 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },['title']:{
          ...formValues['title'],
          value:data.title,
        },['stockoutproductid']:{
          ...formValues['stockoutproductid'],
          value:data.stockoutproductid,
        },['productorderid']:{
          ...formValues['productorderid'],
          value:data.productorderid,
        },['orderid']:{
          ...formValues['orderid'],
          value:data.orderid,
        },['qty']:{
          ...formValues['qty'],
          value:data.qty,
        },['stockoutreqid']:{
          ...formValues['stockoutreqid'],
          value:data.stockoutreqid,
        },
      })
}